import { Chart } from "chart.js";
import { EmptyObject } from "react-hook-form";
import { AnyObject } from "yup";

export const noDataPlugin = {
  id: "noData",
  afterDatasetsDraw: (
    chart: Chart<"bar">,
    _args: EmptyObject,
    options: AnyObject
  ) => {
    const {
      ctx,
      data,
      chartArea: { top, left, width, height }
    } = chart;

    ctx.save();

    const allDataZero = data.datasets.every((dataset) =>
      dataset.data.every((value) => value === 0)
    );

    if (allDataZero) {
      ctx.fillStyle = "rgba(255, 235, 241, 0.3)";
      ctx.fillRect(left, top, width, height);
      ctx.font = "medium-bold 18px sans-serif";
      ctx.fillStyle = "#7E7E8B";
      ctx.textAlign = "center";
      ctx.fillText(options.customMessage, left + width / 2, top + height / 2);
    }
  }
};

Chart.register(noDataPlugin);
